import moment from 'moment';

export const serverTimeFormatDay = 'DD'
export const serverTimeFormatMonth = 'MM'
export const serverTimeFormatYear = 'YYYY'
export const serverDateFormat = `${serverTimeFormatYear}-${serverTimeFormatMonth}-${serverTimeFormatDay}`;

export const serverTime = (time: string) => {
  return moment(time).utc().format('YYYY-MM-DDTHH:mm:ss');
};
